import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase/firebase';
import CompanySidebar from './CompanySidebar';
import TopHeader from '../shared/TopHeader';
import '../../styles/CompanyAdmin.css';

const PAGE_TITLES = {
  '/company':              'Dashboard',
  '/company/employees':    'Employees',
  '/company/add-employee': 'Add Employee',
  '/company/tiers':        'Benefit Tiers',
  '/company/settings':     'Settings',
  '/company/help':         'Help & Guide',
};

const CompanyLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [companyName, setCompanyName] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user || !user.email) {
        localStorage.removeItem('companyData');
        navigate('/company/login', { replace: true });
        return;
      }

      const email = user.email.toLowerCase();
      try {
        const adminSnap = await getDoc(doc(db, 'companyAdmins', email));
        if (!adminSnap.exists()) {
          await signOut(auth);
          localStorage.removeItem('companyData');
          navigate('/company/login', { replace: true });
          return;
        }

        const adminData = adminSnap.data();
        const companySnap = await getDoc(doc(db, 'companies', adminData.companyId));
        if (!companySnap.exists()) {
          await signOut(auth);
          localStorage.removeItem('companyData');
          navigate('/company/login', { replace: true });
          return;
        }

        const companyData = {
          ...companySnap.data(),
          id: companySnap.id,
          adminData,
        };
        localStorage.setItem('companyData', JSON.stringify(companyData));
        setCompanyName(companyData.name || null);
        setVerifying(false);
      } catch (err) {
        console.error('Company admin verification failed:', err);
        await signOut(auth);
        navigate('/company/login', { replace: true });
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  if (verifying) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8fafc',
        color: '#64748b',
        fontFamily: 'Plus Jakarta Sans, sans-serif',
        fontSize: 14,
      }}>
        Verifying access…
      </div>
    );
  }

  const title = PAGE_TITLES[location.pathname] || 'Dashboard';
  const initials = (companyName || 'CA')
    .split(' ')
    .map(s => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase() || 'CA';

  return (
    <div className="loysta-app">
      <CompanySidebar />
      <div className="loysta-main">
        <TopHeader title={title} userInitials={initials} />
        <main className="loysta-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default CompanyLayout;
